import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 420 500",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M107.36 162.82a176.8 176.8 0 01111 111.52 19.76 19.76 0 0037.54 0 176.81 176.81 0 01111-111.52 19.91 19.91 0 000-37.71 176.81 176.81 0 01-111-111.52 19.76 19.76 0 00-37.54 0 176.8 176.8 0 01-111 111.52 19.91 19.91 0 000 37.71zm129.76-95.36A217.53 217.53 0 00313.27 144a217.37 217.37 0 00-76.15 76.5A217.26 217.26 0 00161 144a217.42 217.42 0 0076.12-76.54zm169.36 276.29a98 98 0 01-61.54-61.82 19.76 19.76 0 00-37.54 0 98 98 0 01-61.53 61.82 19.91 19.91 0 000 37.71 98 98 0 0161.53 61.82 19.76 19.76 0 0037.54 0 98 98 0 0161.54-61.82 19.91 19.91 0 000-37.71zM326.18 394A138.85 138.85 0 00295 362.61a138.6 138.6 0 0031.19-31.33 138.6 138.6 0 0031.19 31.33 138.85 138.85 0 00-31.2 31.39zm-152-101.64a98 98 0 01-61.53-61.82 19.77 19.77 0 00-37.54 0 98 98 0 01-61.54 61.82 19.92 19.92 0 000 37.72 98 98 0 0161.54 61.82 19.77 19.77 0 0037.54 0 98 98 0 0161.48-61.9 19.91 19.91 0 000-37.72zm-80.29 50.2a139 139 0 00-31.19-31.33 139.06 139.06 0 0031.19-31.34A138.44 138.44 0 00125 311.18a138.6 138.6 0 00-31.16 31.33zM240.84 480a19.91 19.91 0 11-19.91-20 19.95 19.95 0 0119.91 20m-201-300.86a19.91 19.91 0 11-19.91-20 19.95 19.95 0 0119.91 20M380.2 40a19.91 19.91 0 11-19.91-20 20 20 0 0119.91 20",
      stroke: "none"
    })]
  });
};
const IconGymFeatureCleaning = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "GymFeatureCleaning__IconGymFeatureCleaning",
  componentId: "sc-cc0qfv-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconGymFeatureCleaning };
